import update from '../../../helpers/update';
import {
  getListData,
  getMetadata,
  createRecord,
  updateRecord,
  getRecord,
  deleteRecord,
} from '../../../modules/bin/entityHandlers';
import { CAMPAIGN_ORGANIZER_API_PATH } from '../../../constants/campaignOrganizer';
import {
  CAMPAIGN_ORGANIZERS_MESSAGE_CLEAR,
  CAMPAIGN_ORGANIZERS_METADATA_REQUESTED,
  CAMPAIGN_ORGANIZERS_METADATA_SUCCESS,
  CAMPAIGN_ORGANIZERS_METADATA_FAILURE,
  CAMPAIGN_ORGANIZERS_LIST_DATA_REQUESTED,
  CAMPAIGN_ORGANIZERS_LIST_DATA_SUCCESS,
  CAMPAIGN_ORGANIZERS_LIST_DATA_FAILURE,
  CAMPAIGN_ORGANIZERS_CREATE_REQUESTED,
  CAMPAIGN_ORGANIZERS_CREATE_SUCCESS,
  CAMPAIGN_ORGANIZERS_CREATE_FAILURE,
  CAMPAIGN_ORGANIZERS_UPDATE_REQUESTED,
  CAMPAIGN_ORGANIZERS_UPDATE_SUCCESS,
  CAMPAIGN_ORGANIZERS_UPDATE_FAILURE,
  CAMPAIGN_ORGANIZERS_GET_REQUESTED,
  CAMPAIGN_ORGANIZERS_GET_SUCCESS,
  CAMPAIGN_ORGANIZERS_GET_FAILURE,
  CAMPAIGN_ORGANIZERS_DELETE_REQUESTED,
  CAMPAIGN_ORGANIZERS_DELETE_SUCCESS,
  CAMPAIGN_ORGANIZERS_DELETE_FAILURE,
} from './campaignOrganizerTypes';

export const clearCampaignOrganizerErrors = (record: any) => ({
  type: CAMPAIGN_ORGANIZERS_MESSAGE_CLEAR,
  payload: { key: record },
});

export const getCampaignOrganizerMetadata = (listKey: any) =>
  getMetadata(
    CAMPAIGN_ORGANIZER_API_PATH,
    listKey,
    CAMPAIGN_ORGANIZERS_METADATA_REQUESTED,
    CAMPAIGN_ORGANIZERS_METADATA_SUCCESS,
    CAMPAIGN_ORGANIZERS_METADATA_FAILURE
  );

export const getCampaignOrganizerListData = (
  listKey: any,
  id: any,
  request: any,
  invalidate = false,
  cachedData?: any
) =>
  getListData(
    CAMPAIGN_ORGANIZER_API_PATH,
    listKey,
    id,
    CAMPAIGN_ORGANIZERS_LIST_DATA_REQUESTED,
    CAMPAIGN_ORGANIZERS_LIST_DATA_SUCCESS,
    CAMPAIGN_ORGANIZERS_LIST_DATA_FAILURE,
    request,
    invalidate,
    cachedData
  );

export const getCampaignOrganizerListDataBySearchTerm = (
  listKey: any,
  id: any,
  request: any,
  searchTerm: string
) => {
  const newRequest = update(request, { text: { $set: searchTerm } });
  return getCampaignOrganizerListData(listKey, id, newRequest, true);
};

export const createCampaignOrganizer = (payload: any) =>
  createRecord(
    CAMPAIGN_ORGANIZER_API_PATH,
    CAMPAIGN_ORGANIZERS_CREATE_REQUESTED,
    CAMPAIGN_ORGANIZERS_CREATE_SUCCESS,
    CAMPAIGN_ORGANIZERS_CREATE_FAILURE,
    payload,
    null,
    'recordCreate'
  );

export const updateCampaignOrganizer = (id: number, payload: any) =>
  updateRecord(
    CAMPAIGN_ORGANIZER_API_PATH,
    CAMPAIGN_ORGANIZERS_UPDATE_REQUESTED,
    CAMPAIGN_ORGANIZERS_UPDATE_SUCCESS,
    CAMPAIGN_ORGANIZERS_UPDATE_FAILURE,
    id,
    payload,
    null,
    'recordEdit'
  );

export const getCampaignOrganizer = (id: number) =>
  getRecord(
    CAMPAIGN_ORGANIZER_API_PATH,
    CAMPAIGN_ORGANIZERS_GET_REQUESTED,
    CAMPAIGN_ORGANIZERS_GET_SUCCESS,
    CAMPAIGN_ORGANIZERS_GET_FAILURE,
    id,
    'recordEdit'
  );

export const deleteCampaignOrganizer = (id: number) =>
  deleteRecord(
    CAMPAIGN_ORGANIZER_API_PATH,
    CAMPAIGN_ORGANIZERS_DELETE_REQUESTED,
    CAMPAIGN_ORGANIZERS_DELETE_SUCCESS,
    CAMPAIGN_ORGANIZERS_DELETE_FAILURE,
    id,
    'recordDelete'
  );
